import { useQuery } from '@tanstack/react-query';
import { useParams } from 'react-router-dom';
import { fetchOverviewPatient } from '../services/patient';

export function useOverviewPatient() {
    const { id } = useParams<{ id: string }>();

    return useQuery({
        queryKey: ['patient', id, 'overview'],
        queryFn: () => fetchOverviewPatient(id!),
        enabled: id !== undefined,
        staleTime: 0
    });
}
